// src/components/Footer.js
import React from 'react';
import { Link } from 'react-router-dom';
import { ReactComponent as FacebookIcon } from '../assets/icon-facebook.svg';
import { ReactComponent as InstagramIcon } from '../assets/icon-instagram.svg';
import CookieSettingsLink from './CookieSettingsLink';
import { ReactComponent as LinkedInIcon } from '../assets/icon-linkedin.svg';
import { OVERZICHT_PAD, usePubliekeDoorloopjes } from '../utils/publiekeDoorloopjes';

// --- BEGIN WIJZIGING ---
// Component accepteert nu onPrivacyClick en onContactClick
const Footer = ({ onLoginClick, onPrivacyClick, onContactClick }) => {
  const { doorloopjes } = usePubliekeDoorloopjes();
  return (
    <footer className="main-footer">
      <div className="footer-content">
        <div className="footer-info">
          <span>© Doorloopjes 2025</span>
          <span>Alle rechten voorbehouden</span>
          <a href="#!" onClick={(e) => { e.preventDefault(); onLoginClick(); }}>Inloggen</a>
          {doorloopjes && <Link to={OVERZICHT_PAD}>Alles voor je lespraktijk</Link>}
          <a href="#!" onClick={(e) => { e.preventDefault(); onContactClick(); }}>Contact</a>
          <a href="#!" onClick={(e) => { e.preventDefault(); onPrivacyClick(); }}>Privacybeleid</a>
          <CookieSettingsLink />
        </div>
        <div className="social-icons">
          <a href="https://www.facebook.com/Doorloopjes" target="_blank" rel="noopener noreferrer" aria-label="Facebook">
            <FacebookIcon />
          </a>
          <a href="https://www.linkedin.com/showcase/doorloopjes" target="_blank" rel="noopener noreferrer" aria-label="LinkedIn">
            <LinkedInIcon />
          </a>
          <a href="https://www.instagram.com/doorloopjes.nl/" target="_blank" rel="noopener noreferrer" aria-label="Instagram">
            <InstagramIcon />
          </a>
        </div>
      </div>
    </footer>
  );
};
// --- EINDE WIJZIGING ---

export default Footer;
